module.exports = __webpack_public_path__ + "static/media/pay-mastercard.1b53d11b.png";